import { freddyTheme as theme } from '@coolblue-development/freddy';
export const getInsuranceSelectableBoxStyles = (numberOfProducts) => ({
    gridColumn: 'span 12',
    gap: 0,
    '& label li': {
        marginTop: 0,
    },
    [theme.breakpoint.minWidth('md')]: {
        gridColumn: 'span 6',
        gridTemplateRows: 'subgrid',
        gridRow: numberOfProducts === 1 ? 'span 4' : '1 / span 4',
    },
    [theme.breakpoint.minWidth('lg')]: {
        gridColumn: 'span 4',
        gridRow: 'span 4',
    },
});
//# sourceMappingURL=InsuranceSelectableBox.styles.js.map